export const themeQueryKeys = {
  _base: () => ["themes"],
  all: (includeInactive: boolean) => [
    ...themeQueryKeys._base(),
    { includeInactive },
  ],
  single: (themeId: string) => [...themeQueryKeys._base(), themeId],
};
